import queryString from "query-string";
import { getIsPosEnabled } from "../../Utils";

export const isSalesRestrictedReport = (reportCategory, reportSysName) => {
  const isPosEnabled = getIsPosEnabled();
  const isRestricted = reportCategory?.some(
    ({ sysname }) => sysname === reportSysName,
  );

  return isRestricted && !isPosEnabled;
};

export const npsReportStateSnapshot = (() => {
  const STATE_SNAPSHOT_KEY = "npsrirst";
  const QUERY_PARAM_KEY = "restoreStateSnapshot";

  return {
    capture: (state) => {
      localStorage.setItem(STATE_SNAPSHOT_KEY, JSON.stringify(state));
    },
    get: () => {
      const snapshot = localStorage.getItem(STATE_SNAPSHOT_KEY);
      const parsed = snapshot ? JSON.parse(snapshot) : null;
      return typeof parsed === "object" && parsed !== null ? parsed : null;
    },
    drop: () => {
      localStorage.removeItem(STATE_SNAPSHOT_KEY);
    },
    canRestore: (url) => {
      const searchParams = queryString.parseUrl(url).query;
      return searchParams?.[QUERY_PARAM_KEY] === "true";
    },
    markUrlAsForRestoration: (url) => {
      const searchParams = queryString.parseUrl(url).query;
      const nextUrl = url.split("?")[0].replace(window.location.origin, "");
      const nextParams = queryString.stringify({
        ...searchParams,
        [QUERY_PARAM_KEY]: "true",
      });
      return `${nextUrl}?${nextParams}`;
    },
    unmarkUrl: (url) => {
      const searchParams = queryString.parseUrl(url).query;
      const nextUrl = url.split("?")[0].replace(window.location.origin, "");
      delete searchParams[QUERY_PARAM_KEY];
      const nextParams = queryString.stringify(searchParams);
      return nextParams ? `${nextUrl}?${nextParams}` : nextUrl;
    },
  };
})();
